import { Flex } from '@mediahuis/chameleon-react';
import styled from 'styled-components';

const FlexWithCursor = styled(Flex)`
  cursor: ${props => (props.checkout10InputsDisabled ? 'initial' : 'pointer')};
`;

export default FlexWithCursor;
